import { connect } from 'react-redux';

import { AboutBuilderMain, IAboutBuilderMainProps } from './index';
import { NavigationLinkTypes } from '../../constants/navigation';
import { IState } from '../../store';
import { setNavigationLink } from '../../store/navigation/actions';
import { trackingPhoneEvent } from '../../store/tracking/mobile';
import { TTypedThunkDispatch } from '../../types/store';

type TAboutBuilderMainContainerStateProps = Pick<IAboutBuilderMainProps, 'village'>;
type TAboutBuilderMainContainerDispatchProps = Pick<
  IAboutBuilderMainProps,
  'trackShowPhoneClick' | 'setNavigationLink'
>;

export function mapStateToProps(state: IState): TAboutBuilderMainContainerStateProps {
  return {
    village: state.villageData.village,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): TAboutBuilderMainContainerDispatchProps {
  return {
    setNavigationLink: () => dispatch(setNavigationLink(NavigationLinkTypes.Builder)),
    trackShowPhoneClick() {
      dispatch(trackingPhoneEvent('Open_KP_card_blockDeveloper'));
    },
  };
}

export const AboutBuilderMainContainer = connect<
  TAboutBuilderMainContainerStateProps,
  TAboutBuilderMainContainerDispatchProps
>(
  mapStateToProps,
  mapDispatchToProps,
)(AboutBuilderMain);
